import { imagePath } from "@/config/imgPath";
import { jsStaticUrl } from "@/const";
/**
 * @description 通过分类获取图片路径
 * @param classify 分类名称
 * @param imgName 图片名
 * @returns
 */
export const getImagePath = (classify, imgName) => {
  if (!imgName) {
    return "";
  } else {
    return jsStaticUrl + "/assets" + imagePath[classify].replace("${content}", imgName);
  }
};